// ============================================================================
// authDomain.js — a Firebase bejelentkezési tartomány (authDomain) futásidejű kiválasztása (2026-10-10).
//
// A PROBLÉMA (valós hiba, a lineage0.com saját tartomány bekötésekor): az env/*.json authDomain-je a projekt
// Hosting-címe (<projectId>.web.app). Ha az alkalmazást MÁS tartományról töltik be (pl. lineage0.com), a bejelentkezés
// átirányítása/ablaka másik origin-en fut, mint az alkalmazás - a böngésző (Chrome tárolás-particionálása, Safari ITP)
// ilyenkor elveszíti a bejelentkezés eredményét, HIBAÜZENET NÉLKÜL: a felhasználó végigmegy a Google-on, visszatér, és újra a
// belépő képernyőn találja magát (hurok). A fejléc CSP frame-src-je ráadásul az idegen hitelesítési keretet is letiltja.
//
// A MEGOLDÁS: az authDomain az a tartomány, amelyről az alkalmazás ténylegesen fut. A Firebase Hosting minden hozzá kötött
// tartományon (web.app, firebaseapp.com, saját tartomány) kiszolgálja a /__/auth/** útvonalakat, így a bejelentkezés
// ugyanazon az origin-en marad végig. Helyi fejlesztésnél (localhost, IP) az env szerinti érték marad.
//
// EGYSZERI KÉZI BEÁLLÍTÁS minden új tartományhoz (a kód ezt nem tudja elvégezni):
//   1. Firebase Console -> Authentication -> Settings -> Authorized domains: a tartomány hozzáadása;
//   2. Google Cloud Console -> APIs & Services -> Credentials -> a projekt "Web client" OAuth-azonosítója:
//        Authorized JavaScript origins:  https://<tartomány>
//        Authorized redirect URIs:       https://<tartomány>/__/auth/handler
// ============================================================================

const IP_CIM = /^\d{1,3}(\.\d{1,3}){3}$/;

/**
 * @param {string} configDomain  az env/*.json szerinti authDomain
 * @param {string} host          az oldal tartományneve (window.location.hostname)
 * @returns {string} a használandó authDomain
 */
export function futasiAuthDomain(configDomain, host) {
  const h = typeof host === "string" ? host.trim().toLowerCase() : "";
  if (!h) return configDomain;
  if (h === "localhost" || h.endsWith(".localhost") || IP_CIM.test(h) || h.includes(":")) return configDomain;
  if (!/^[a-z0-9]([a-z0-9.-]*[a-z0-9])?$/.test(h)) return configDomain;
  return h;
}
